import { Country } from '~/lib/api/smartsend/types';
import { ProductImage } from '../product/ProductImage';
import { toIso2Code } from '../../lib/helpers/IsoCodeHelper';

import { P2GBox, P2GGrid, P2GText } from '@parcel2go/core-ui';

interface props {
  country: Country;
}

export const CustomerSelectionCountry: React.FC<props> = (props) => {
  if (!props.country) {
    return null;
  }

  return (
    <P2GBox backgroundColour="#f3f3f3" p={1}>
      <P2GGrid container wrap="nowrap" alignItems="center" gap={2}>
        <P2GGrid item flexShrink={1}>
          <ProductImage
            style={{ height: '20px' }}
            product={{
              ImageUrl: `/~/.flags/svg/${toIso2Code(props.country.CountryIsoCode).toLocaleLowerCase()}.svg`
            }}
          />
        </P2GGrid>
        <P2GGrid item flexGrow={1}>
          <P2GText>
            <strong>{props.country.Name}</strong>
          </P2GText>
        </P2GGrid>
      </P2GGrid>
    </P2GBox>
  );
};
